import { render } from "./ReligousForm.vue?vue&type=template&id=6ee3608d"
import script from "./ReligousForm.vue?vue&type=script&lang=js"
export * from "./ReligousForm.vue?vue&type=script&lang=js"

import "./ReligousForm.vue?vue&type=style&index=0&id=6ee3608d&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__